export default {
  mounted(el, binding) {
    // Функция обработчика кликов
    el.__clickOutsideHandler__ = (event) => {
      // Проверяем, что клик произошел вне элемента
      if (!el.contains(event.target)) {
        // Вызываем переданный обработчик
        binding.value(event);
      }
    };

    // Добавляем обработчик на документ
    document.addEventListener('click', el.__clickOutsideHandler__);
  },
  unmounted(el) {
    // Удаляем обработчик при удалении элемента
    document.removeEventListener('click', el.__clickOutsideHandler__);
    delete el.__clickOutsideHandler__;
  },
};